import React from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'

export const Exceptions = ({ currentItemsDict, deleteItem }) => {
  const onDelete = exception => {
    deleteItem(
      currentItemsDict.filter(l => {
        return l.address !== exception.address
      }),
      exception
    )
  }

  return currentItemsDict.length > 0 ? (
    <div className={styles.nfts}>
      {currentItemsDict.map((exception, key) => (
        <div key={key} className={styles.nft}>
          <div key={key} className={styles.nftData}>
            <div className={styles.iconContainer}>
              <Image
                src={`/site-api/thumbnails?url=${encodeURIComponent(
                  exception.imgUrl
                )}&size=30`}
                width='30'
                height='30'
                alt={exception.name}
              />
            </div>
            <span>{exception.name}</span>
            <span
              className={styles.clickable}
              onClick={() => onDelete(exception)}
            >
              &times;
            </span>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <></>
  )
}
